import {ReactNode} from 'react';
import {Box, Button, Container, Paper, Stack} from '@mui/material';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import {Link as RouterLink} from 'react-router-dom';
import {localizedLandingUrl} from '../../common/landingUrl';
import AuthFooter from './AuthFooter';
import LanguageSwitcher from '@mybake/ui/components/header/LanguageSwitcher';
import {useAppTranslation} from '@mybake/ui/hooks/useAppTranslation';

export default function RegistrationLayout({children, backToLogin = false}: {children: ReactNode; backToLogin?: boolean}) {
    const {t, i18n} = useAppTranslation();
    return <Box sx={{minHeight: '100vh', bgcolor: 'background.default', py: {xs: 2, md: 6}}}>
        <Container maxWidth="sm">
            <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{mb: 3}}>
                {backToLogin
                    ? <Button component={RouterLink} to="/login" startIcon={<ArrowBackRoundedIcon/>}>{t('auth:recovery.back')}</Button>
                    : <Button component="a" href={localizedLandingUrl(i18n.resolvedLanguage || i18n.language)} startIcon={<ArrowBackRoundedIcon/>}>{t('registration:back')}</Button>}
                <LanguageSwitcher/>
            </Stack>
            <Paper elevation={0} sx={{p: {xs: 3, sm: 5}, border: 1, borderColor: 'divider', borderRadius: 4}}>
                <Box component="img" src={`${process.env.PUBLIC_URL}/branding/mybake-wordmark-3200px.png`} alt="MyBake.pro" width={3200} height={712} sx={{display: 'block', width: 160, maxWidth: '100%', height: 'auto', mb: 2}}/>
                {children}
            </Paper>
            <Button component={RouterLink} to="/login" fullWidth sx={{mt: 2}}>{t('registration:login')}</Button>
            <AuthFooter/>
        </Container>
    </Box>;
}
